const url = {
  backendURL: process.env.REACT_APP_BACKEND_URL,
  backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
};

export default url;
